export default __webpack_public_path__ + "static/media/tv.d86ba733.svg";